import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from 'angularfire2/firestore';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { StorageService } from './storage.service';
import { ThrowStmt } from '@angular/compiler';
import { Articulo } from '../models/articulo';
import { DatosService } from './datos.service';
@Injectable({
  providedIn: 'root'
})
export class ArticulosService {

  
  
  private articuloCollection: AngularFirestoreCollection<Articulo>;
  private articulos: Observable<Articulo[]>;

  private catsCollection: AngularFirestoreCollection<any>;
  private cats: Observable<any[]>;
  private slider: Observable<any[]>;
  private links: Observable<any[]>;
  constructor( private db: AngularFirestore,
               private ciaServ: DatosService ) {

   
    
  }

  rebuild() {
   
  }

 
  getArticulos() {
    return this.articulos = this.db.collection<Articulo>('PRODUCTOS', (ref) =>
    ref.orderBy('ar_orden')).valueChanges();
  }
  getClientes() {
    return this.articulos = this.db.collection<Articulo>('CLIENTES', (ref) =>
    ref).valueChanges();
  }
  getArticulosOrdenados() {
    return this.articulos = this.db.collection<Articulo>('PRODUCTOS', (ref) =>
    ref.orderBy('ar_orden')).valueChanges();
  }

  getCats() {
    return this.cats = this.db.collection<any>('CATEGORIAS', (ref) =>
    ref).valueChanges();
  }

  getSlider() {
    return this.cats = this.db.collection<any>('SLIDER', (ref) =>
    ref).valueChanges();
  }
  getLinks() {
    return this.cats = this.db.collection<any>('LINKS', (ref) =>
    ref).valueChanges();
  }

  getArticulo( id: string ) {
    this.articuloCollection = this.db.collection<Articulo>('PRODUCTOS');
    return this.articuloCollection.doc<Articulo>(id).valueChanges();
  }

  getCons() {
    this.articuloCollection = this.db.collection<Articulo>('CONS');
    return this.articuloCollection.doc<Articulo>('cons').valueChanges();
  }

  addArticulo( articulo: Articulo) {
    articulo.ar_codigo = this.db.createId();
    this.articuloCollection = this.db.collection<Articulo>('PRODUCTOS');
    return this.articuloCollection.doc(articulo.ar_codigo).set(articulo);
  }
  addCliente( cl: any) {
    cl.cl_codigo = this.db.createId();
    this.articuloCollection = this.db.collection<Articulo>('CLIENTES');
    return this.articuloCollection.doc(cl.cl_codigo).set(cl);
  }
  updateArticulo( articulo: Articulo ) {
    this.articuloCollection = this.db.collection<Articulo>('PRODUCTOS');
    return this.articuloCollection.doc(articulo.ar_codigo).update(articulo);
  }

  updateCliente( articulo: any ) {
    this.articuloCollection = this.db.collection<Articulo>('CLIENTES');
    return this.articuloCollection.doc(articulo.cl_codigo).update(articulo);
  }
  

  removeArticulo( id: string) {
    this.articuloCollection = this.db.collection<Articulo>('PRODUCTOS');
    return this.articuloCollection.doc(id).delete();
  }
}
